import React from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  TextField,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SetupStepHelp from "./setup/SetupStepHelp";

const EtapaUsuarios = ({
  showManualForm,
  setShowManualForm,
  manualUsers,
  newUser,
  setNewUser,
  handleAddManualUser,
  hasImportedUsers,
}) => {
  // Função para alternar entre o formulário manual e o upload de planilha
  const toggleForm = () => setShowManualForm(!showManualForm);

  // Função para adicionar um user manualmente
  const handleAddClient = (e) => {
    if (e.key === "Enter") {
      handleAddManualUser();
      document.getElementById("nome").focus();
    }
  };

  return (
    <Box sx={{ width: "100%"}}>
      <SetupStepHelp stepKey="users" />
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        📥 Cadastro Manual de Usuários
      </Typography>
      <Typography variant="body2" gutterBottom>
        Importe uma planilha ou cadastre manualmente seus usuários.
      </Typography>

      {!showManualForm ? (
        <Paper
          elevation={1}
          sx={{
            border: "2px dashed #90caf9",
            padding: 4,
            mt: 3,
            textAlign: "center",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#e3f2fd",
              boxShadow: 2,
            },
          }}
        >
          <Typography variant="subtitle1" gutterBottom>
            Arraste sua planilha aqui ou
          </Typography>
          <Button variant="contained" sx={{ mt: 1 }}>
            Selecionar Arquivo
          </Button>
          <Typography variant="caption" display="block" sx={{ mt: 2 }}>
            Formatos aceitos: .xlsx, .csv — Colunas: Nome, Email, Telefone
          </Typography>
          <Button variant="text" size="small" href="/modelo-users.xlsx" sx={{ mt: 1 }}>
            📎 Baixar modelo
          </Button>
        </Paper>
      ) : (
        <Box mt={4}>
          <Typography variant="subtitle1" fontWeight="bold">
            Cadastro Manual
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                id="nome"
                label="Nome"
                value={newUser.nome}
                onChange={(e) => setNewUser({ ...newUser, nome: e.target.value })}
                onKeyDown={handleAddClient}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Email"
                value={newUser.email}
                onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                onKeyDown={handleAddClient}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Telefone"
                value={newUser.telefone}
                onChange={(e) => setNewUser({ ...newUser, telefone: e.target.value })}
                onKeyDown={handleAddClient}
              />
            </Grid>
          </Grid>
          <Box mt={2} display="flex" gap={2}>
            <Button variant="contained" onClick={handleAddManualUser}>
              Adicionar
            </Button>
          </Box>
        </Box>
      )}

    <Box mt={4} display="flex" gap={1}>
        <Button variant="outlined" onClick={toggleForm}>
          {showManualForm?"Importar planilha":"Cadastrar Manualmente"}
        </Button>
      </Box>

      {hasImportedUsers && (
        <Box mt={4}>
          <Typography variant="subtitle1" fontWeight="bold">
            Usuários cadastrados:
          </Typography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Nome</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Telefone</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {manualUsers.map((user, index) => (
                  <TableRow key={index}>
                    <TableCell>{user.nome}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.telefone}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      
    </Box>
  );
};

export default EtapaUsuarios;
